<template>
  <v-card flat>
    <v-card-text>
      <v-card-title>
        <div>
          <h1 class="text-h4 mr-2">Email Template Snippets</h1>
          <v-subheader>Reusable,&nbsp;<a href="https://shopify.github.io/liquid/basics/introduction/"
              target="_blank">Scriptable</a>&nbsp;HTML Snippets for Email Templates</v-subheader>
        </div>
        <refresh-spinner v-model="isRefreshingData" @click="refreshList"></refresh-spinner>
        <v-spacer></v-spacer>
        <v-text-field @keydown.native.escape="search = ''" label="Search" single-line clearable v-model="search"
          persistent-hint hint="Filter by name">
        </v-text-field>
        <v-spacer></v-spacer>
        <v-btn color="primary" :to="{ 'name': 'new_email_builder_snippet_path' }">
          <v-icon left>mdi-plus</v-icon>
          New Snippet
        </v-btn>
      </v-card-title>
    </v-card-text>
    <v-data-table :headers="tableColumns" :items="queriedData" item-key='id' class="elevation-1">
      <template v-slot:item.is_default="{ item }">
        <v-icon v-if="item.is_default" color="green">mdi-check-bold</v-icon>
      </template>
      <template v-slot:item.type="{ item }">
        {{ snippetTypeDesc(item.type) }}
      </template>
      <!--
        -- ACTIONS
      -->
      <template v-slot:item.actions="{ item }">

        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-icon v-on="on" medium class="mr-2" @click="handleEdit(item)">mdi-pencil</v-icon>
          </template>
          <span>Edit Html Snippet</span>
        </v-tooltip>

        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-icon v-on="on" medium class="mr-2" @click="handlePreview(item, false)">mdi-binoculars</v-icon>
          </template>
          <span>Preview Html Snippet</span>
        </v-tooltip>

      </template>

    </v-data-table>
  </v-card>
</template>

<script>
import { mapState } from 'vuex'
import RefreshSpinner from '@/components/ui/RefreshSpinner'
import { R4UtilsApi, HtmlSnippetApi } from '@/services'
import { propEq, find, prop } from 'ramda'

export default {
  components: {
    [RefreshSpinner.name]: RefreshSpinner
  },
  computed: {
    ...mapState('DealerStore', ['dealer']),
    ...mapState('ApplicationStore', ['dealerScopedView']),

    queriedData() {
      if (!this.search) {
        return this.tableData
      }
      let result = this.tableData.filter(row => {
        let isIncluded = false
        for (let key of this.propsToSearch) {
          let rowValue = row[key] ? row[key].toString() : ''
          if (
            rowValue.includes &&
            rowValue.toLowerCase().includes(this.search.toLowerCase())
          ) {
            isIncluded = true
          }
        }
        return isIncluded
      })
      return result
    }
  },
  data: function () {
    return {
      isRefreshingData: false,
      search: '',
      propsToSearch: ['name'],
      tableColumns: [
        { text: 'Name', value: 'name' },
        { text: 'Type', value: 'type' },
        { text: 'Is Default', value: 'is_default' },
        { text: 'Actions', value: 'actions' }
      ],
      tableData: [],
      snippetTypes: []
    }
  },
  watch: {
  },
  methods: {
    refreshList() {
      this.isRefreshingData = true
      HtmlSnippetApi.getTypes()
        .then((types) => {
          this.snippetTypes = types.data
        })
        .then(() => {
          HtmlSnippetApi.fetch()
            .then((footerData) => {
              this.tableData = footerData.data
            })
        })
        .catch(error => {
          this.$flash({
            showClose: true,
            message: `Error Loading Email Footers. ${error.message}`,
            type: 'error',
            duration: 0
          })
          this.isRefreshingData = false
        })
        .finally(() => {
          this.isRefreshingData = false
        })
    },
    handleEdit(item) {
      this.$router.push({ name: 'edit_email_builder_snippet_path', params: { id: item.id } })
    },
    loadSnippetTypes() {
      HtmlSnippetApi.getTypes()
        .then((types) => {
          this.snippetTypes = types.data
        })
        .catch(error => {
          this.$logger.error('Error loading snippet types', error.message)
          this.$flash({
            showClose: true,
            message: 'Error loading snippet types. Reload and try again. ' + error.message,
            type: 'error',
            duration: 0
          })
        })
    },
    snippetTypeDesc(type) {
      return prop('title', find(propEq('name', type))(this.snippetTypes))
    },

    // handleShow (item) {
    //   this.$router.push({ name: 'email_campaign_path', params: { id: item.id } })
    // }
    handlePreview(item) {
      if (item.id) {
        HtmlSnippetApi.preview(item.id, this.dealer.id)
          .then((htmlTemplatePreview) => {
            R4UtilsApi.openHtmlInNewTab(htmlTemplatePreview.data.html)
          })
          .catch(error => {
            this.$flash({
              showClose: true,
              message: 'Error Loading Email Templates. Reload to try again.' + error.message,
              type: 'error',
              duration: 0
            })
          })
      } else {
        alert('This Html Snippet does not have associated data to preview')
      }
    }
  },
  mounted: function () {
    return this.refreshList()
  }
}
</script>
